<template>
	<div class="float_nav" :class="{'float_nav_fixed': fixed}">
		<ul>
			<li v-if="list.length" class="menu_item">
				<div class="menu_hd text_one" :class="{'bg_theme': active.indexOf('1_') != -1,'menu_hd_active': active.indexOf('1_') != -1}" @click="handleMenuClick('1_1', list[0].uid, 1)">康复案例</div>
				<ul>
					<li v-for="(v, i) in list" :key="v.uid" class="menu_expand_item text_one" :class="{'text_theme': active == '1_' + (i + 1)}" @click="handleMenuClick('1_' + (i + 1), v.uid, i + 1)">{{ v.title }}</li>
				</ul>
			</li>
			<li class="menu_item">
				<div class="menu_hd text_one" :class="{'bg_theme': active == '2','menu_hd_active': active == '2'}" @click="handleMenuClick('2')">治疗流程</div>
			</li>
			<li class="menu_item">
				<div class="menu_hd text_one" :class="{'bg_theme': active == '3','menu_hd_active': active == '3'}" @click="handleMenuClick('3')">康复数据</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			fixed: {
				type: Boolean,
				default: false
			},
			list: {
				type: Array,
				default() { return []; }
			},
			index: {
				type: Number,
				default: 0
			}
		},
		mounted() {
			let type = this.$route.query.type || '';
			if (type == 'case' || type == '') {
				this.active = '1_1';
			} else if (type == 'process') {
				this.active = '2';
			} else {
				this.active = '3';
			}
		},
		data() {
			return {
				active: ''
			}
		},
		methods: {
			/*************** @Events *******************/
			// 点击菜单
			handleMenuClick(index, case_id, num) {
				let emit_index = index.indexOf('1_') != -1 ? 1 : parseInt(index);
				this.active = index;
				this.$emit('onClick', emit_index, case_id, num);
			}
		},
		watch: {
			index(newVal) {
				newVal == 1 && (this.active = '2');
				newVal == 2 && (this.active = '3');
			}
		}
	}
</script>

<style scoped>
	.float_nav{ display: block;position: absolute;z-index: 99;width: 227px;top: 542px;left: 50%;margin-left: -600px; }
	.float_nav_fixed{ position: fixed;top: 80px; }
	.float_nav .menu_item{ margin-bottom: 4px;background: #fff; }
	.float_nav .menu_hd{ padding: 10px;background: rgb(234, 239, 239);font-size: 18px;color: #6b8189;text-align: center;line-height: 30px;cursor: pointer; }
	.float_nav .menu_hd_active{ color: #fff; }
	.float_nav .menu_expand_item{ padding: 10px;color: #6b8189;text-align: center;line-height: 30px;cursor: pointer; }
	
	@media screen and (max-width: 1200px) {
		.float_nav_fixed{ left: 0;margin-left: 0; }
	}
</style>
